import * as React from 'react';
import { Mutation } from 'react-apollo';
import AdminStartSisSyncSetup from 'admin/rostering/components/AdminStartSisSyncSetup';

import ADMIN_SET_SIS_SYNC_TYPE from 'admin/rostering/mutations/AdminSetSisSyncType.gql';

import { SyncType } from 'globalTypes';
import {
  AdminSetSisSyncType,
  AdminSetSisSyncTypeVariables,
} from 'admin/rostering/mutations/__generated__/AdminSetSisSyncType';

type Props = {
  orgUuid: string;
  orgName: string;
  updateCallback: () => void;
};

export default function AdminStartSisSyncSetupContainer(props: Props) {
  const { orgUuid, orgName, updateCallback } = props;

  return (
    <Mutation<AdminSetSisSyncType, AdminSetSisSyncTypeVariables>
      mutation={ADMIN_SET_SIS_SYNC_TYPE}
      update={() => updateCallback()}>
      {setSisSyncType => {
        return (
          <AdminStartSisSyncSetup
            orgName={orgName}
            selectSyncType={(syncType: SyncType) =>
              setSisSyncType({
                variables: { districtUuid: orgUuid, syncType: syncType },
              })
            }
          />
        );
      }}
    </Mutation>
  );
}
